import * as React from 'react';
import { MenuItemProps } from '../../StylableHorizontalMenu.types';

export const populateWithChildren = (
  items: Array<MenuItemProps>,
  slotMap: Record<string, string>,
  renderChildren?: () => Array<React.ReactNode>,
): Array<MenuItemProps & { children?: React.ReactNode }> => {
  const children = React.Children.toArray(
    renderChildren?.(),
  ) as Array<React.ReactElement>;

  return items.map(item => {
    if (!item.slot) {
      return item;
    }
    const compId = slotMap[item.slot];
    return {
      ...item,
      children: children.find(child => child?.props?.id === compId),
    };
  });
};
